import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"

interface AnalyticsParams {
  startDate: string
  endDate: string
  departmentId: number
  operatorId?: number
  callTypeId?: number
  intentDirection?: string
}

export const analyticsApi = createApi({
  reducerPath: "analyticsApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/analytics" }),
  endpoints: builder => ({
    getSummaryStatistics: builder.query<any, AnalyticsParams | null>({
      query: params => ({ url: "summary-statistics", params }),
    }),
    getSummaryTotalStatistics: builder.query<any, AnalyticsParams | null>({
      query: params => ({ url: "summary-total-statistics", params }),
    }),
    getClientTypeDistribution: builder.query<any, AnalyticsParams & { page: number; pageSize: number }>({
      query: params => ({ url: "client-type-distribution", params }),
    }),
    getAverageScoresByCriteria: builder.query<any, AnalyticsParams & { page: number; pageSize: number }>({
      query: params => ({ url: "average-scores-by-criteria", params }),
    }),
    getOperatorData: builder.query<any, AnalyticsParams & { page: number; pageSize: number }>({
      query: params => ({ url: "operator-data", params }),
    }),
    getWeeklyAverages: builder.query<any, AnalyticsParams & { page: number; pageSize: number }>({
      query: params => ({ url: "weekly-averages", params }),
    }),
    getResultPerformanceSummary: builder.query<any, AnalyticsParams | null>({
      query: params => ({ url: "result-performance-summary", params }),
    }),
    getOperatorCallTypeReport: builder.query<any, any>({
      query: params => ({
        url: "operator-call-type-report-json",
        params,
      }),
    }),
  }),
})

export const {
  useGetSummaryStatisticsQuery,
  useGetSummaryTotalStatisticsQuery,
  useGetClientTypeDistributionQuery,
  useGetAverageScoresByCriteriaQuery,
  useGetOperatorDataQuery,
  useGetWeeklyAveragesQuery,
  useGetResultPerformanceSummaryQuery,
  useGetOperatorCallTypeReportQuery,
} = analyticsApi
